export enum StaffType {
  CastingDirector = 'Casting Director',
  SessionDirector = 'Session Director',
  Assistant = 'Assistant',
  Owner = 'Owner',
}
